import { createStandardAction } from 'typesafe-actions';
export var collectRioEvent = createStandardAction('RIO/COLLECT')();